import styled from "styled-components"

export const InforTitleLi = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  list-style-type: none;
`

export const InforValueP = styled.p`
  font-size: 1.375rem;
  color: black;
`
